export default __webpack_public_path__ + "static/media/julia.9342ea81.svg";